import {
  ARCHIVE_BUSINESS_SPACE_OPERATION,
  CREATE_BUSINESS_SPACE_OPERATION,
  LIST_BUSINESS_SPACES_OPERATION,
  RESTORE_BUSINESS_SPACE_OPERATION,
  UPDATE_BUSINESS_SPACE_OPERATION,
  type GeneratedArchiveBusinessSpaceResponse,
  type GeneratedCreateBusinessSpaceRequest,
  type GeneratedCreateBusinessSpaceResponse,
  type GeneratedListBusinessSpacesResponse,
  type GeneratedRestoreBusinessSpaceResponse,
  type GeneratedUpdateBusinessSpaceRequest,
  type GeneratedUpdateBusinessSpaceResponse,
} from './generated-business';
import { performAuthorizedRequest, replacePathParams } from './business-request';

export async function listBusinessSpacesRequest(
  token: string,
  businessId: number
): Promise<GeneratedListBusinessSpacesResponse> {
  return performAuthorizedRequest<GeneratedListBusinessSpacesResponse>(
    token,
    {
      ...LIST_BUSINESS_SPACES_OPERATION,
      path: replacePathParams(LIST_BUSINESS_SPACES_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter os espaços. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível carregar os espaços agora.',
    }
  );
}

export async function createBusinessSpaceRequest(
  token: string,
  businessId: number,
  space: GeneratedCreateBusinessSpaceRequest
): Promise<GeneratedCreateBusinessSpaceResponse> {
  return performAuthorizedRequest<GeneratedCreateBusinessSpaceResponse>(
    token,
    {
      ...CREATE_BUSINESS_SPACE_OPERATION,
      path: replacePathParams(CREATE_BUSINESS_SPACE_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      body: space,
      networkErrorMessage:
        'Não foi possível criar o espaço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível criar o espaço agora.',
    }
  );
}

export async function updateBusinessSpaceRequest(
  token: string,
  businessId: number,
  spaceId: number,
  space: GeneratedUpdateBusinessSpaceRequest
): Promise<GeneratedUpdateBusinessSpaceResponse> {
  return performAuthorizedRequest<GeneratedUpdateBusinessSpaceResponse>(
    token,
    {
      ...UPDATE_BUSINESS_SPACE_OPERATION,
      path: replacePathParams(UPDATE_BUSINESS_SPACE_OPERATION.path, {
        business_id: businessId,
        id: spaceId,
      }),
    },
    {
      body: space,
      networkErrorMessage:
        'Não foi possível atualizar o espaço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível atualizar o espaço agora.',
    }
  );
}

export async function archiveBusinessSpaceRequest(
  token: string,
  businessId: number,
  spaceId: number
): Promise<GeneratedArchiveBusinessSpaceResponse> {
  return performAuthorizedRequest<GeneratedArchiveBusinessSpaceResponse>(
    token,
    {
      ...ARCHIVE_BUSINESS_SPACE_OPERATION,
      path: replacePathParams(ARCHIVE_BUSINESS_SPACE_OPERATION.path, {
        business_id: businessId,
        id: spaceId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível arquivar o espaço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível arquivar o espaço agora.',
    }
  );
}

export async function restoreBusinessSpaceRequest(
  token: string,
  businessId: number,
  spaceId: number
): Promise<GeneratedRestoreBusinessSpaceResponse> {
  return performAuthorizedRequest<GeneratedRestoreBusinessSpaceResponse>(
    token,
    {
      ...RESTORE_BUSINESS_SPACE_OPERATION,
      path: replacePathParams(RESTORE_BUSINESS_SPACE_OPERATION.path, {
        business_id: businessId,
        id: spaceId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível restaurar o espaço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível restaurar o espaço agora.',
    }
  );
}
